import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 24
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};
export function IncludesSection() {
  const handleScrollToPrice = () => {
    const el = document.getElementById('precio-final');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full px-5 py-16 md:py-24 bg-[#F5F0EA]" data-id="element-203">
      <div className="max-w-3xl mx-auto" data-id="element-204">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-semibold text-[#2C2825] mb-12 text-center" data-id="element-205">
          Todo lo que incluye tu Mapa de Ojeras™
        </motion.h2>

        <div className="space-y-4" data-id="element-206">
          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.05
        }} className="bg-white rounded-xl p-5 md:p-6 border border-[#B8A99A]/15 flex items-start gap-4" data-id="element-207">
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-208">📘</span>
            <div data-id="element-209">
              <h3 className="font-semibold text-[#2C2825] text-[15px] mb-1" data-id="element-210">
                Ebook completo (PDF)
              </h3>
              <p className="text-[#2C2825]/65 text-sm leading-relaxed" data-id="element-211">
                Guía visual con los 4 tipos de ojeras, causas, ingredientes
                clave y errores comunes.
              </p>
            </div>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.1
        }} className="bg-white rounded-xl p-5 md:p-6 border border-[#B8A99A]/15 flex items-start gap-4" data-id="element-212">
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-213">🔍</span>
            <div data-id="element-214">
              <h3 className="font-semibold text-[#2C2825] text-[15px] mb-1" data-id="element-215">
                Test visual de 3 minutos
              </h3>
              <p className="text-[#2C2825]/65 text-sm leading-relaxed" data-id="element-216">
                Identifica tu tipo de ojera dominante con fotos de referencia y
                preguntas guiadas.
              </p>
            </div>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.15
        }} className="bg-white rounded-xl p-5 md:p-6 border border-[#B8A99A]/15 flex items-start gap-4" data-id="element-217">
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-218">🌳</span>
            <div data-id="element-219">
              <h3 className="font-semibold text-[#2C2825] text-[15px] mb-1" data-id="element-220">
                Árbol de decisión
              </h3>
              <p className="text-[#2C2825]/65 text-sm leading-relaxed" data-id="element-221">
                Te lleva directo a tu rutina sin leer todo el ebook. Resultado →
                acción.
              </p>
            </div>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.2
        }} className="bg-white rounded-xl p-5 md:p-6 border border-[#B8A99A]/15 flex items-start gap-4" data-id="element-222">
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-223">✅</span>
            <div data-id="element-224">
              <h3 className="font-semibold text-[#2C2825] text-[15px] mb-1" data-id="element-225">
                Checklist de ingredientes
              </h3>
              <p className="text-[#2C2825]/65 text-sm leading-relaxed" data-id="element-226">
                Qué buscar (y qué evitar) en tus productos según tu tipo de
                ojera.
              </p>
            </div>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.25
        }} className="bg-white rounded-xl p-5 md:p-6 border border-[#B8A99A]/15 flex items-start gap-4" data-id="element-227">
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-228">📅</span>
            <div data-id="element-229">
              <h3 className="font-semibold text-[#2C2825] text-[15px] mb-1" data-id="element-230">
                Tracker de 7 días (imprimible)
              </h3>
              <p className="text-[#2C2825]/65 text-sm leading-relaxed" data-id="element-231">
                Registra tu rutina diaria y observa los cambios día a día.
              </p>
            </div>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.3
        }} className="bg-white rounded-xl p-5 md:p-6 border border-[#B8A99A]/15 flex items-start gap-4" data-id="element-232">
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-233">💄</span>
            <div data-id="element-234">
              <h3 className="font-semibold text-[#2C2825] text-[15px] mb-1" data-id="element-235">
                Guía de corrección óptica
              </h3>
              <p className="text-[#2C2825]/65 text-sm leading-relaxed" data-id="element-236">
                Técnicas de maquillaje para disimular ojeras según su tipo.
                Resultados desde el día 1.
              </p>
            </div>
          </motion.div>
        </div>

        {/* CTA #2 */}
        <motion.div {...fadeInUp} transition={{
        ...fadeInUp.transition,
        delay: 0.35
      }} className="mt-12 text-center" data-id="element-237">
          <button onClick={handleScrollToPrice} className="w-full sm:w-auto px-8 py-4 bg-[#C4956A] hover:bg-[#A87B54] text-white font-semibold text-base rounded-xl transition-colors duration-200 shadow-lg shadow-[#C4956A]/20" data-id="element-238">
            Quiero empezar mi plan de 7 días
          </button>
          <p className="mt-4 flex items-center justify-center gap-2 text-sm text-[#2C2825]/50" data-id="element-239">
            <MailIcon className="w-4 h-4" data-id="element-240" />
            Descarga inmediata por email · Acceso de por vida
          </p>
        </motion.div>

        {/* Printables Image */}
        <motion.div {...fadeInUp} transition={{
        ...fadeInUp.transition,
        delay: 0.4
      }} className="mt-12" data-id="element-241">
          <img src="https://cdn.magicpatterns.com/uploads/x7ohGP7poqEMRnX4bFaEve/plantillas-ojeras.png" alt="Plantillas impresas de Rutina 2+1 y Tracker de 7 días sobre un baño" className="w-full rounded-2xl shadow-lg shadow-[#2C2825]/6" data-id="element-242" />
        </motion.div>
      </div>
    </section>;
}